import React, { Component } from 'react';
import { LeftMenu } from './menu/LeftMenu';
import { NavMenu } from './menu/NavMenu';
export class Content extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenLeftMenu: false
        };
    }
    handleOpenLeftMenu(open) {
        this.setState({
            isOpenLeftMenu: open
        })
    }
    render() {
        const { isOpenLeftMenu } = this.state;
        return (
            <>
                <NavMenu handleOpenLeftMenu={this.handleOpenLeftMenu.bind(this)} isOpenLeftMenu={isOpenLeftMenu} />
                <div className="main-block">
                    <LeftMenu isOpen={isOpenLeftMenu} handleOpenLeftMenu={this.handleOpenLeftMenu.bind(this)} />
                    {this.props.children}
                </div>
            </>
        );
    }
}
